/**
 * トップページに戻る
 * トップページの表示言語を指定できる
 * @param lng 言語情報、ja or en
 */
export function ReturnTopPage(lng:string) {
    window.location.href = `/competition/registration${lng !== "" ? `?lng=${lng}` : ""}`;
}